import * as ACTIONS from 'constant/action/category'
import * as LOADER_ACTIONS from 'constant/action/loader'
import { createAction } from 'redux-actions'
import { getPossibleSites } from 'action/site'

const updateCategories = createAction(ACTIONS.UPDATE_CATEGORIES)
const updateCategoryNavigation = createAction(ACTIONS.UPDATE_CATEGORY_NAVIGATION)
const updateLoading = createAction(LOADER_ACTIONS.UPDATE_LOADING)
const updateCategorySubmitting = createAction(LOADER_ACTIONS.UPDATE_CATEGORY_SUBMITTING)
const updateManagementCategories = createAction(ACTIONS.UPDATE_MANAGEMENT_CATEGORIES)

export const getAllCategories = (management = false) => async (dispatch, getState, { category }) => {
  dispatch(updateLoading(true))
  const results = await category.getCategories(management)
  if (management) {
    dispatch(updateManagementCategories(results))
  } else {
    dispatch(updateCategories(results))
  }

  dispatch(updateCategoryNavigation(results))

  dispatch(updateLoading(false))
}

export const addCategory = (newCategory) => async (dispatch, getState, { category }) => {
  try {
    dispatch(updateCategorySubmitting(true))

    const response = await category.addCategory(newCategory)

    dispatch(getPossibleSites())
    dispatch(getAllCategories(true))
    dispatch(getAllCategories())
    dispatch(updateCategorySubmitting(false))

    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const editCategory = (editCategory, originalCategory) => async (dispatch, getState, { category }) => {
  try {
    dispatch(updateCategorySubmitting(true))

    const userTypeRemoved = originalCategory.user_type_uuids.filter((el) => {
      return !editCategory.user_type_uuids.includes(el)
    })

    const organisationsRemoved = originalCategory.organisation_uuids.filter((el) => {
      return !editCategory.organisation_uuids.includes(el)
    })

    const categoryObj = {
      ...editCategory,
      organisation_uuids_removed: organisationsRemoved,
      user_type_uuids_removed: userTypeRemoved
    }
    const response = await category.editCategory(categoryObj, true)

    dispatch(getPossibleSites())
    dispatch(getAllCategories(true))
    dispatch(getAllCategories())
    dispatch(updateCategorySubmitting(false))

    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const deleteCategory = (uuid) => async (dispatch, getState, { category }) => {
  await category.deleteCategory(uuid)
  dispatch(getPossibleSites())
  dispatch(getAllCategories(true))
}

export const addSubCategory = (uuid, subCategory) => async (dispatch, getState, { category }) => {
  try {
    dispatch(updateCategorySubmitting(true))

    const response = await category.addSubCategory({ category_uuid: uuid, ...subCategory })

    dispatch(getPossibleSites())
    dispatch(getAllCategories(true))
    dispatch(updateCategorySubmitting(false))

    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const editSubCategory = (subCategory, originalCategory) => async (dispatch, getState, { category }) => {
  try {
    dispatch(updateCategorySubmitting(true))

    const userTypeRemoved = originalCategory.user_type_uuids.filter((el) => {
      return !subCategory.user_type_uuids.includes(el)
    })

    const organisationRemoved = originalCategory.organisation_uuids.filter((el) => {
      return !subCategory.organisation_uuids.includes(el)
    })

    const subcategoryObj = {
      ...subCategory,
      organisation_uuids_removed: organisationRemoved,
      user_type_uuids_removed: userTypeRemoved
    }
    const response = await category.editSubCategory(subcategoryObj)

    dispatch(getPossibleSites())
    dispatch(getAllCategories(true))
    dispatch(getAllCategories())
    dispatch(updateCategorySubmitting(false))

    return response
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const deleteSubCategory = (uuid) => async (dispatch, getState, { category }) => {
  await category.deleteSubCategory(uuid)
  dispatch(getPossibleSites())
  dispatch(getAllCategories(true))
}

export const searchCategories = (searchTerm) => async (dispatch, getState, { category }) => {
  dispatch(updateLoading(true))

  const response = await category.searchCategories(searchTerm)

  dispatch(updateManagementCategories(response))
  dispatch(updateLoading(false))
}

export const saveCategoriesOrder = (categories, subCategory) => async (dispatch, getState, { category }) => {
  if (subCategory) {
    dispatch(updateCategorySubmitting(true))
  } else {
    dispatch(updateLoading(true))
  }

  const response = await category.saveCategoriesOrder(categories)
  dispatch(updateCategories(response))
  if (subCategory) {
    dispatch(updateCategorySubmitting(false))
  } else {
    dispatch(updateLoading(false))
  }
}
